import { render, staticRenderFns } from "./VisaoGeralComponent.vue?vue&type=template&id=7178d4a9&scoped=true"
import script from "./VisaoGeralComponent.vue?vue&type=script&lang=js"
export * from "./VisaoGeralComponent.vue?vue&type=script&lang=js"
import style0 from "./VisaoGeralComponent.vue?vue&type=style&index=0&id=7178d4a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7178d4a9",
  null
  
)

export default component.exports